module.exports = __webpack_public_path__ + "img/Primordial-Process-8.22514313.png";